import React, { createContext, useContext, useMemo } from 'react'
import { useCmsContent } from './useCmsContent'

const CmsContext = createContext({
  pageContent: {},
  services: [],
})

export const useCms = () => useContext(CmsContext)

export const CmsProvider = ({ children }) => {
  const { pageContent, services, loading } = useCmsContent()

  const value = useMemo(
    () => ({
      pageContent,
      services,
    }),
    [pageContent, services]
  )

  return (
    <CmsContext.Provider value={value}>
      {loading ? undefined : children}
    </CmsContext.Provider>
  )
}
